/* assets/wishlist.js */
(() => {
  const SHOP_ID = window.Shopify?.shop || location.host;
  const STORAGE_KEY = `wishlist:${SHOP_ID}`;

  const read = () => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (_) { return []; }
  };
  const write = (arr) => localStorage.setItem(STORAGE_KEY, JSON.stringify(arr));
  const contains = (handle, variantId) =>
    read().some(i => i.handle === handle && String(i.variantId) === String(variantId));

  const add = (handle, variantId) => {
    const list = read();
    if (!contains(handle, variantId)) list.push({ handle, variantId: String(variantId) });
    write(list); trigger();
  };
  const remove = (handle, variantId) => {
    write(read().filter(i => !(i.handle === handle && String(i.variantId) === String(variantId))));
    trigger();
  };
  const trigger = () => {
    const list = read();
    window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { list } }));
    updateCount(); updateButtons();
  };

function updateCount() {
  const count = read().length;
  document.querySelectorAll('[data-wishlist-count]').forEach(el => {
    el.textContent = count;
    const bubble = el.closest('.cart-count-bubble, .count-bubble');
    if (bubble) bubble.classList.toggle('hidden', count === 0);
  });
  const headerLink = document.querySelector('.header__icon--wishlist');
  if (headerLink) headerLink.classList.toggle('is-filled', count > 0);
}

  function updateButtons() {
    document.querySelectorAll('[data-wishlist-button]').forEach(btn => {
      const handle = btn.dataset.productHandle;
      const idInput = btn.closest('form')?.querySelector('input[name="id"]');
      const variantId = idInput?.value || btn.dataset.variantId;
      const inWL = handle && variantId && contains(handle, variantId);
      btn.setAttribute('aria-pressed', inWL ? 'true' : 'false');
      btn.classList.toggle('is-active', inWL);
      const text = btn.querySelector('[data-wishlist-text]');
      if (text) text.textContent = inWL ? (text.dataset.added || 'In Wishlist') : (text.dataset.add || 'Add to wishlist');
      const icon = btn.querySelector('.wishlist-heart');
      if (icon) icon.classList.toggle('is-filled', inWL);
    });
  }

  document.addEventListener('click', (e) => {
    const wlBtn = e.target.closest('[data-wishlist-button]');
    if (wlBtn) {
      e.preventDefault();
      const handle = wlBtn.dataset.productHandle;
      const idInput = wlBtn.closest('form')?.querySelector('input[name="id"]');
      const variantId = idInput?.value || wlBtn.dataset.variantId;
      if (!handle || !variantId) return;
      contains(handle, variantId) ? remove(handle, variantId) : add(handle, variantId);
      return;
    }

    const removeBtn = e.target.closest('[data-remove-wishlist]');
    if (removeBtn) {
      remove(removeBtn.dataset.handle, removeBtn.dataset.variantId);
      renderWishlistPage();
      return;
    }

    const cartBtn = e.target.closest('[data-add-to-cart]');
    if (cartBtn) {
      e.preventDefault();
      addToCart(cartBtn.dataset.variantId, 1);
      return;
    }
    const clearBtn = e.target.closest('[data-wishlist-clear]');
if (clearBtn) {
  e.preventDefault();
  localStorage.setItem(STORAGE_KEY, JSON.stringify([]));
  trigger();
  renderWishlistPage();
  return;
}
  });

  async function addToCart(variantId, quantity = 1) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.description || data?.message || 'Could not add to cart');
      window.dispatchEvent(new Event('cart:refresh'));
    } catch (err) {
      alert(err.message);
    }
  }

  function money(cents) {
    try { return Shopify.formatMoney(cents); }
    catch (_) { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: 'USD' }); }
  }

async function renderWishlistPage() {
  const grid = document.getElementById('wishlist-grid');
  if (!grid) return;

  const empty = document.querySelector('[data-wishlist-empty]');
  const list = read();

  if (!list.length) {
    if (empty) empty.hidden = false;
    grid.innerHTML = '';
    return;
  }
  if (empty) empty.hidden = true;
  grid.innerHTML = '';

  for (const item of list) {
    try {
      const res = await fetch(`/products/${item.handle}.js`);
      if (!res.ok) continue;
      const product = await res.json();
      const variant = product.variants.find(v => String(v.id) === String(item.variantId)) || product.variants[0];
      const url = `/products/${product.handle}${product.variants.length > 1 ? `?variant=${variant.id}` : ''}`;
      const img = (variant.featured_image?.src || product.images[0]) || '';
      const available = variant.available;
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

      const priceHtml = onSale
        ? `<div class="price wl-price">
            <div class="price__container">
              <div class="price__sale">
                <span class="price-item price-item--sale price-item--last">${money(variant.price)}</span>
                <span class="price-item price-item--regular"><s>${money(variant.compare_at_price)}</s></span>
              </div>
            </div>
          </div>`
        : `<div class="price wl-price">
            <div class="price__container">
              <div class="price__regular">
                <span class="price-item price-item--regular">${money(variant.price)}</span>
              </div>
            </div>
          </div>`;

      const percent = onSale ? Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100) : 0;
      const badgeHtml = `
        <div class="card__badge">
          ${onSale ? `<span class="badge badge--sale">-${percent}%</span>` : ''}
          ${!available ? `<span class="badge badge--sold-out">Sold out</span>` : ''}
        </div>`;

      const variantTitle = variant.title && variant.title !== 'Default Title'
        ? `<div class="wl-variant caption-with-letter-spacing">${variant.title}</div>` : '';

      const html = `
        <div class="wl-card card-wrapper">
          <div class="card card--standard">
            <div class="card__inner color-background-2 gradient">
              <div class="card__media">
                <a href="${url}" class="full-unstyled-link wl-media-link">
                  ${img ? `<img src="${img}?width=600"
                                srcset="${img}?width=360 360w, ${img}?width=533 533w, ${img}?width=720 720w, ${img}?width=940 940w, ${img}?width=1066 1066w"
                                sizes="(min-width: 1200px) 25vw, (min-width: 990px) 33vw, (min-width: 750px) 50vw, 100vw"
                                loading="lazy" alt="${variant.featured_image?.alt || product.title}">` : ''}
                </a>
                ${badgeHtml}
                <button class="wl-remove" title="Remove" data-remove-wishlist data-handle="${product.handle}" data-variant-id="${variant.id}">
                  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                    <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
                  </svg>
                </button>
              </div>
            </div>
            <div class="card__content">
              <h3 class="wl-title card__heading h5"><a href="${url}" class="full-unstyled-link">${product.title}</a></h3>
              ${variantTitle}
              ${priceHtml}
              <div class="wishlist-card-actions">
                <button class="button button--primary button--full-width" data-add-to-cart data-variant-id="${variant.id}" ${available ? '' : 'disabled'}>
                  ${available ? 'Add to cart' : 'Sold out'}
                </button>
              </div>
            </div>
          </div>
        </div>
      `;

      grid.insertAdjacentHTML('beforeend', html);
    } catch (e) {
      console.warn('Wishlist render failed for', item, e);
    }
  }
}

  window.Wishlist = { read, add, remove, contains, renderWishlistPage };

  document.addEventListener('DOMContentLoaded', () => {
    updateCount(); updateButtons(); renderWishlistPage();
  });
  window.addEventListener('wishlist:updated', renderWishlistPage);
})();